import AdminInstance from 'modules/admin/repository';

export const getCronLogs = (page, size, search, filters) => AdminInstance.getScriptLogs({
  page, size, search, filters, type: 'cron',
});
